const bundle = (state) => {
    return state.bundle
}
const product_id = (state) => {
    return state.product_id
}
const bundle_id = (state) => {
    return state.bundle_id
}
const selectedBundleItems = (state) => {
    return state.selectedBundleItems
}
const selectedBundleItemsSumm = (state) => {
    return state.selectedBundleItemsSumm
}

export default {
    bundle,
    product_id,
    bundle_id,
    selectedBundleItems,
    selectedBundleItemsSumm
}
